module.exports = __webpack_public_path__ + "static/dev-docs-icon-9216bd78c8538b0e451d1141b85dc0dc.svg";